module.exports = __webpack_public_path__ + "static/media/FMB_icon6.0bef4e22.svg";